import Button from '@ui/Button';
import React, { useRef } from 'react';
import Typography from '@ui/Typography';
import ProfileAvatarEditor from '@ui/ProfileAvatarEditor/ProfileAvatarEditor';
import StyledContainedButton from '@/components/Styled/StyledContainedButton';
import { useFilePicker } from 'use-file-picker';
import getQualifiedImageUrl from '@utils/imageUrlProcessor';
import StyledButtonNew from '@/components/Styled/StyledButtonNew';

function EditAvatarProfileStep(props) {
  const { profileImage, onSubmit, saving } = props;
  const [editor, setEditor] = React.useState(null);
  const setEditorRef = (e) => setEditor(e);

  const [newProfileImage, setNewProfileImage] = React.useState(null);
  const [isUploaded, setIsUploaded] = React.useState(false);

  const [openFileSelector, { filesContent, loading, errors: fileErrors }] =
    useFilePicker({
      readAs: 'DataURL',
      accept: 'image/*',
      multiple: false,
      maxFileSize: 5, // in megabytes
    });

  const showFileSelector = () => {
    openFileSelector();
  };

  React.useEffect(() => {
    if (filesContent && filesContent[0]) {
      setNewProfileImage(filesContent[0].content);
      setIsUploaded(true);
    }
  }, [filesContent]);

  const handleSave = () => {
    if (editor) {
      const canvas = editor.getImageScaledToCanvas();
      canvas.toBlob((blob) => {
        const editedImage = new File([blob], 'edited-image.png', {
          type: 'image/png',
        });
        handleImageSubmit(editedImage);
      }, 'image/png');
    }
  };

  const handleImageSubmit = (file) => {
    if (file) {
      onSubmit({
        avatar: Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      });
    }
  };

  return (
    <div className="flex w-full flex-1 flex-col gap-12">
      <Typography variant="dialogtitle">Edit Profile Image</Typography>
      <div className="flex flex-col gap-6">
        <ProfileAvatarEditor
          profileImage={getQualifiedImageUrl(profileImage)}
          newProfileImage={newProfileImage}
          setIsUploaded={setIsUploaded}
          setEditorRef={setEditorRef}
        />
        <div className="flex-rows flex justify-between gap-4">
          <div className="flex-flow-col">
            <Button
              variant="outlined"
              color="primary"
              onClick={showFileSelector}
              type="button">
              Upload Image
            </Button>
          </div>

          {/* {isUploaded ? (
            <div className="flex-flow-col">
              <StyledButtonNew
                variant="filled"
                color="primary"
                type="submit"
                loading={saving}
                onClick={handleSave}>
                Save
              </StyledButtonNew>
            </div>
          ) : (
            <div className="flex-flow-col">
              <StyledButtonNew
                disabled
                variant="outlined"
                color="primary"
                type="submit"
                loading={saving}>
                Save
              </StyledButtonNew>
            </div>
          )} */}
          <div className="flex-flow-col">
            <StyledButtonNew
              variant="filled"
              color="primary"
              type="submit"
              loading={saving}
              onClick={handleSave}>
              Save
            </StyledButtonNew>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditAvatarProfileStep;
